import { render, staticRenderFns } from "./HouseholdDashboard.vue?vue&type=template&id=64ba69e6&scoped=true&"
import script from "./HouseholdDashboard.vue?vue&type=script&lang=js&"
export * from "./HouseholdDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ba69e6",
  null
  
)

export default component.exports